import { client } from '@atlassian/rovo-content-bridge-api';

// TODO - remove once new mechanism has rolled out to prod
// on whiteboards side, we will register ourself as both clients to fast-5
export var CONFLUENCE_WHITEBOARD_CLIENT_ID = client('confluence-whiteboard');
var CONFLUENCE_WHITEBOARD_CLIENT_ID_PREFIX = 'confluence-whiteboard';
export var getConfluenceWhiteboardClientId = function getConfluenceWhiteboardClientId(contentId) {
  return client("".concat(CONFLUENCE_WHITEBOARD_CLIENT_ID_PREFIX, "-").concat(contentId));
};